/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, Renderer2 } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { Event, NavigationEnd, NavigationStart, Router} from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {


  constructor(private router: Router, private titleService: Title,private analytics : AnalyticsService, private renderer: Renderer2) {

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if(event.url === '/auth/login'){
          this.renderer.addClass(document.body, 'homelogin');
          //this.renderer.removeClass(document.body, 'dashboard');
        } else if (event.url === '/auth/requestpass'){
          this.renderer.addClass(document.body, 'homelogin');
        }else {
          this.renderer.removeClass(document.body, 'homelogin');
        }

        // if(event.url === '/auth/requestpass'){
        //   this.renderer.addClass(document.body, 'homelogin');
        //   this.renderer.removeClass(document.body, 'dashboard');
        // }

        // if(event.url === '/pages/dashboard'){
        //   this.renderer.addClass(document.body, 'dashboard');
        //   this.renderer.removeClass(document.body, 'homelogin');
        // }
      }

      if (event instanceof NavigationEnd) {
      }
  });
  }

  ngOnInit(): void {
    
    this.analytics.trackPageViews();
  }
}
